module.exports = __webpack_public_path__ + "static/img/21.3b334d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/customization/21.png
// module id = WBsX
// module chunks = 1